import { useState, useContext } from "react";
import {
  Typography,
  Box,
  Grid,
  Table,
  TableRow,
  TableCell,
  TableBody,
  TableHead,
  TableContainer,
} from "@mui/material";
import moment from "moment";
//Import from project
import "../../Style/pagestyle.scss";
import { AuthContext } from "../../Context/AuthContext";
import { PageHeaderTitle, ButtonCreate } from "../../Utils/Component";
import EmptyData from "../../Components/Include/EmptyData/EmptyData";
import useGetExpensePagination from "../../Hooks/useGetExpensePagination";
import LoadingPage from "../../Utils/LoadingPage";
import FooterPagination from "../../Utils/FooterPagination";
import useWithDimension from "../../Hooks/useWithDimension";
import { currencyFormat, currencyFormatRiel } from "../../Function/DynamicFn";
import ExpenseForm from "../../Components/Expense/ExpenseForm";
import ExpenseAction from "../../Components/Expense/ExpenseAction";
import { SelectExpenseType } from "../../Components/Include/DynamicSelect/DynamicSelect";
import { SelectDatePicker } from "../../Components/Include/SelectDatePicker/SelectDatePicker";

export default function Expense() {
  // Change Language
  const { t, language } = useContext(AuthContext);
  const [type, setType] = useState({ id: "", title: "" });
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const { width } = useWithDimension();

  const {
    page,
    limit,
    setPage,
    refetch,
    loading,
    tableData,
    setLoading,
    handleLimit,
    paginationData,
  } = useGetExpensePagination({ type, fromDate, toDate });

  return (
    <div className="page-container">
      <PageHeaderTitle
        classPage={t("class-page-title")}
        classSlash="slash-title"
        routeTo={"/other"}
        pageTitle={t("page_other")}
        detailTitle={t("page_expense")}
      />

      <Box sx={{ marginTop: "20px" }}>
        <Grid container spacing={3}>
          <Grid item xs={6} sm={6} md={4} lg={3} xl={2}>
            <Typography className={t("class-name-text-field-title")}>
              {t("thead_from_date")}
            </Typography>
            <SelectDatePicker
              value={fromDate}
              onChange={(val) => setFromDate(val)}
            />
          </Grid>
          <Grid item xs={6} sm={6} md={4} lg={3} xl={2}>
            <Typography className={t("class-name-text-field-title")}>
              {t("thead_to_date")}
            </Typography>
            <SelectDatePicker
              value={toDate}
              onChange={(val) => setToDate(val)}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={3} xl={2}>
            <Typography className={t("class-name-text-field-title")}>
              {t("thead_type")}
            </Typography>
            <SelectExpenseType
              buttonAdd={false}
              value={type}
              onChange={(val) => setType(val)}
              className="text-field"
            />

            {/* <SelectExpenseType
              value={values?.type}
              onChange={(val) => setFieldValue("type", val)}
              className="text-field"
            /> */}
          </Grid>
          <Grid item xs={12} sm={6} md={12} lg={3} xl={6}>
            <ButtonCreate
              handleOpen={handleOpen}
              classBtn={"btn-create"}
              classIcon={"icon-add"}
            />

            {open && (
              <ExpenseForm
                open={open}
                setRefetch={refetch}
                dialogTitle={"Create"}
                handleClose={handleClose}
              />
            )}
          </Grid>
        </Grid>
      </Box>

      <Box className="body-container">
        <TableContainer sx={{ maxWidth: `${width}px` }}>
          <Table className="table">
            <TableHead className="header-row">
              <TableRow>
                <TableCell
                  className={t("class-name-header-title-start")}
                  width={"5%"}
                >
                  {t("thead_no")}
                </TableCell>

                <TableCell
                  className={t("class-name-header-title")}
                  width={"10%"}
                >
                  {t("thead_date")}
                </TableCell>

                <TableCell
                  className={t("class-name-header-title")}
                  width={"10%"}
                >
                  {t("thead_type")}
                </TableCell>

                <TableCell
                  className={t("class-name-header-title")}
                  align="right"
                  width={"10%"}
                >
                  {t("thead_exchange_rate")} (៛)
                </TableCell>

                <TableCell
                  className={t("class-name-header-title")}
                  align="right"
                  width={"10%"}
                >
                  {t("thead_amount")} ($)
                </TableCell>

                <TableCell
                  className={t("class-name-header-title")}
                  align="right"
                  width={"10%"}
                >
                  {t("thead_amount")} (៛)
                </TableCell>

                {/* <TableCell
                  className={t("class-name-header-title")}
                  align="right"
                  width={"10%"}
                >
                  {t("thead_total_amount")} ($)
                </TableCell> */}

                <TableCell
                  className={t("class-name-header-title")}
                  width={"30%"}
                >
                  {t("thead_description")}
                </TableCell>

                <TableCell
                  className={t("class-name-header-title-end")}
                  width={"5%"}
                ></TableCell>
              </TableRow>
            </TableHead>
            {loading ? (
              <TableBody className="body">
                <TableRow className="body-row">
                  <TableCell colSpan={12} className="body-cell">
                    <LoadingPage />
                  </TableCell>
                </TableRow>
              </TableBody>
            ) : (
              <>
                {tableData?.length === 0 || tableData?.length === undefined ? (
                  <TableBody className="body">
                    <TableRow className="body-row">
                      <TableCell colSpan={12} className="body-cell">
                        <EmptyData />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                ) : (
                  <TableBody className="body">
                    {tableData?.map((row, index) => {
                      return (
                        <TableRow className={"body-row"} key={index}>
                          <TableCell className="body-cell-start">
                            {index + 1}
                          </TableCell>

                          <TableCell className="body-cell">
                            {moment(row?.date).format("DD-MMM-YYYY")}
                          </TableCell>

                          <TableCell className="body-cell">
                            {language === "en"
                              ? row?.type?.engType
                              : row?.type?.khType}
                          </TableCell>

                          <TableCell
                            className="body-cell"
                            sx={{
                              color: "#131870 !important",
                              fontWeight: "bold",
                              textAlign: "right",
                            }}
                          >
                            {currencyFormatRiel(row?.exchangeRate)} ៛
                          </TableCell>

                          <TableCell
                            className="body-cell"
                            sx={{
                              color: "#131870 !important",
                              fontWeight: "bold",
                              textAlign: "right",
                            }}
                          >
                            $ {currencyFormat(row?.amountUSD)}
                          </TableCell>

                          <TableCell
                            className="body-cell"
                            sx={{
                              color: "#131870 !important",
                              fontWeight: "bold",
                              textAlign: "right",
                            }}
                          >
                            {currencyFormatRiel(row?.amountKHR)} ៛
                          </TableCell>

                          {/* <TableCell
                            className="body-cell"
                            sx={{
                              color: "#131870 !important",
                              fontWeight: "bold",
                              textAlign: "right",
                            }}
                          >
                            {currencyFormatRiel(row?.amountKHR)} ៛
                          </TableCell> */}

                          <TableCell className="body-cell">
                            {row?.remark}
                          </TableCell>

                          <TableCell className="body-cell-end" align="right">
                            <ExpenseAction
                              editData={row}
                              setRefetch={refetch}
                            />
                          </TableCell>
                        </TableRow>
                      );
                    })}
                  </TableBody>
                )}
              </>
            )}
          </Table>
        </TableContainer>
        {/* ==================== Pagination  ============================= */}
        <FooterPagination
          totalPages={paginationData?.totalPages}
          totalDocs={paginationData?.totalDocs}
          limit={limit}
          page={page}
          setPage={setPage}
          handleLimit={handleLimit}
          setLoading={setLoading}
          Type="student"
        />
      </Box>
    </div>
  );
}
